import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AllotmentPreferences } from '../types/allotment-preferences.types';

interface SaveAllotmentPreferencesPayload {
  'allotment-preferences'?: AllotmentPreferences;
}

@Injectable()
export class AllotmentPreferencesService {
  private readonly apiHost: string;

  constructor(
    private readonly httpClient: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) environmentConfig: EnvironmentConfig
  ) {
    this.apiHost = environmentConfig.northstar.host.api as string;
  }

  public save(
    preferences: AllotmentPreferences
  ): Observable<AllotmentPreferences> {
    const url = `${this.apiHost}/api/settings/allotment-preferences`;

    return this.httpClient.post(url, preferences, { observe: 'response' }).pipe(
      map((response: HttpResponse<AllotmentPreferences | SaveAllotmentPreferencesPayload>) => {
        if (response.status === 200 || response.status === 201) {
          const responseBody = response.body as SaveAllotmentPreferencesPayload;

          return (
            responseBody?.['allotment-preferences'] ||
            (response.body as AllotmentPreferences) ||
            preferences
          );
        }

        throw new Error('Cannot save allotment preferences');
      })
    );
  }
}